import { agentFetch } from "../agentFetch";
import {
  consumeAgentSseStream,
  type AgentSseHandlers,
} from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";

/**
 * Stream one conversational turn via POST /{agent}/run/activities (SSE).
 */
export async function streamAgentMessage(
  base: string,
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers,
  errorPrefix: string,
): Promise<AgentChatResponse> {
  const response = await agentFetch(`${base}/run/activities`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream",
      "session-id": sessionId,
    },
    body: JSON.stringify({ message }),
  });

  return consumeAgentSseStream(response, handlers, errorPrefix);
}
